import request from '@/utils/request'

export default {
  // 查询分类列表
  industryCategoryList (query) {
    return request({
      url: '/setting/industryCategory/list',
      method: 'get',
      params: query
    })
  }
}
